module.exports = __webpack_public_path__ + "static/media/discover.fe4fa44f.svg";